import { render, staticRenderFns } from "./popOrderView.vue?vue&type=template&id=568a8754&"
import script from "./popOrderView.vue?vue&type=script&lang=js&"
export * from "./popOrderView.vue?vue&type=script&lang=js&"
import style0 from "./popOrderView.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports